<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="pa-0">
        <div v-if="item.title" class="pt-10 px-3 item">
          <v-row justify="center" no-gutters>
            <v-col md="10" lg="9">
              <TitleWidget class="text-center" color="white">
                {{ item.title }}
              </TitleWidget>

              <img
                v-if="item.img"
                class="d-block mt-8 mt-md-10 item-img"
                loading="lazy"
                :src="files + item.img + '?resize=1&w=960'"
                :alt="item.title"
                width="100%"
              />

              <div
                v-if="item.text"
                class="white--text text-body-1 mt-8 ck-content item-text"
                v-html="item.text"
              ></div>
            </v-col>
          </v-row>
        </div>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";

const _config = {
  mod: "traceability",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-image: url(../assets/img/bg/traceability.jpg);
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;

  &-img {
    max-height: 70vh;
    -o-object-fit: contain;
    object-fit: contain;
  }
}

.item::v-deep {
  .item-text {
    b,
    strong {
      color: white !important;
    }
  }
}

.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
